import { request } from '../http'

interface Ilogin {
  account: string
  password: string
  captcha: string
}
interface Elogin {
  mobile: string
  mobileVerificationCode: string
}

interface WechatLogin {
  /**
   * 用户名/邮箱/手机号
   */
  account: string
  /**
   * 验证码
   */
  captcha: string
  /**
   * 登录类型 默认0账户密码方式,1:手机,验证码方式
   */
  loginType: number
  /**
   * 微信openid
   */
  openid: string
  /**
   * 密码
   */
  password: string
  [property: string]: any
}

export function fetchLogin(data: Ilogin) {
  // const methodInstance = request.Post<Service.ResponseResult<Api.Login.Info>>('/user/membercenter/login', data)
  const methodInstance = request.Post<Service.ResponseResult<Api.Login.Info>>('/user/membercenter/login', { ...data, sourceSite: '会员中心' })
  methodInstance.meta = {
    authRole: null,
  }
  return methodInstance
}

/**
 *  二次登录验证接口
 */
export function loginSecond(data: Ilogin) {
  const methodInstance = request.Post<Service.ResponseResult<Api.Login.Info>>('/user/membercenter/loginSecond', data)
  methodInstance.meta = {
    authRole: null,
  }
  return methodInstance
}

/**
 *  短信登录
 */
export function fetchEmailLogin(data: Elogin) {
  // const methodInstance = request.Post<Service.ResponseResult<Api.Login.Info>>('/user/membercenter/loginByMobile', data)
  const methodInstance = request.Post<Service.ResponseResult<Api.Login.Info>>('/user/membercenter/loginByMobile', { ...data, sourceSite: '会员中心' })
  methodInstance.meta = {
    authRole: null,
  }
  return methodInstance
}

/**
 *  发送手机验证码
 */
export function sendLoginSMS(data: any) {
  const methodInstance = request.Post('/user/membercenter/sendLoginSMS', data)
  methodInstance.meta = {
    authRole: null,
  }
  return methodInstance
}

/**
 *  获取微信二维码
 */
export function getWeChatQRPic(params: any) {
  const methodInstance = request.Get('/user/weChatOfficialAccount/getWeChatQRPic', { params })
  methodInstance.meta = {
    // 标识为blob数据
    isBlob: true,
    authRole: null, // 是否需要携带token
  }
  return methodInstance
}

/**
 *  轮询获取二维码扫码状态
 */
export function checkWxLoginStatus(data: any) {
  // const methodInstance = request.Post('/user/weChatOfficialAccount/checkWxLoginStatus', data)
  const methodInstance = request.Post('/user/weChatOfficialAccount/checkWxLoginStatus', { ...data, sourceSite: '会员中心' })
  methodInstance.meta = {
    isFormPost: true, // json格式
  }
  return methodInstance
}

/**
 *  获取小程序二维码
 */
export function getMiniProgramLoginQrCode(params: any) {
  const methodInstance = request.Get('/user/wechat/getMiniProgramLoginQrCode', { params })
  methodInstance.meta = {
    // 标识为blob数据
    isBlob: true,
    authRole: null, // 是否需要携带token
  }
  return methodInstance
}

/*
*
未找到,或未开始 notExist
生成微信登录二维码 qrcode
关注-账号未绑定微信openid,应该登录/注册->绑定 subscribeUnbound
关注-已有账号绑定了此微信openid subscribeBound
扫码-未绑定微信openid,应该登录/注册->绑定 SCANUnbound
取消关注-解除绑定 unsubscribe
*/
/**
 *  轮询获取小程序二维码扫码状态
 */
export function checkMiniProgramScanStatus(data: any) {
  const methodInstance = request.Post('/user/wechat/checkMiniProgramScanStatus', { ...data, sourceSite: '会员中心' })
  methodInstance.meta = {
    isFormPost: true, // json格式
  }
  return methodInstance
}

/**
 *  通过openid，绑定会员号
 */
export function bindingWechatOpenid(data: WechatLogin) {
  const methodInstance = request.Post<Service.ResponseResult<Api.Login.Info>>('/user/membercenter/bindingWechatOpenid', data)
  return methodInstance
}

export function fetchUpdateToken(data: any) {
  const method = request.Post<Service.ResponseResult<Api.Login.Info>>('/updateToken', data)
  method.meta = {
    authRole: 'refreshToken',
  }
  return method
}

export function fetchUserRoutes(params: { id: number }) {
  return request.Get<Service.ResponseResult<AppRoute.RowRoute[]> >('/getUserRoutes', { params })
}

/**
 *  找回密码-步骤1 通过用户名/手机/邮箱 查询用户信息
 */
export function findPwdGetUser(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/membercenter/findPwdGetUser', data)
  return methodInstance
}

/**
 *  找回密码-步骤2:发送验证码
 */
export function findPwdSendCode(data: any) {
  const methodInstance = request.Post('/user/membercenter/findPwdSendCode', data)
  methodInstance.meta = {
    authRole: null,
  }
  return methodInstance
}

/**
 *  找回密码-步骤3: 校验验证码
 */
export function findPwdCheckCode(data: any) {
  const methodInstance = request.Post('/user/membercenter/findPwdCheckCode', data)
  methodInstance.meta = {
    authRole: null,
  }
  return methodInstance
}

/**
 *  找回密码-步骤4: 重置密码
 */
export function findPwdReSetPwd(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/membercenter/findPwdReSetPwd', data)
  return methodInstance
}

/**
 *  获取行业内容
 */
export function getListIndustrySector() {
  return request.Get<Service.ResponseResult<AppRoute.RowRoute[]> >('/user/common/winiisDatalist/getListWiniisDataistRecursion', { params: { classname: 'IndustrySector' } })
}

/**
 *  生成一个安全的跳转链接，指向目标网站
 */
export function generateSafeRedirectUrl(targetUrl: string) {
  return request.Get<Service.ResponseResult<AppRoute.RowRoute[]> >('/user/membercenter/generateSafeRedirectUrl', { params: { targetUrl } })
}

/**
 *  验证跳转code
 */
export function validateRedirectCode(shortCode: string) {
  return request.Get<Service.ResponseResult<AppRoute.RowRoute[]> >('/user/membercenter/validateRedirectCode', { params: { shortCode } })
}
